import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * A stage name a CRM sent that no stage answers to, in the Alerts bell: its
 * updates wait until the client creates the stage or says which stage it is
 * (owner, 22 Oct 2026: "whatever is not created, flag it and let the client
 * know the pending webhooks are waiting for us to confirm the stage").
 * GET /api/crm/waiting returns [{ connection, value, n, last }].
 */
const CRM_NAME = { zoho: 'Zoho', hubspot: 'HubSpot', salesforce: 'Salesforce', freshsales: 'Freshsales', pipedrive: 'Pipedrive', custom: 'Your CRM' };
const CARD_PATH = { zoho: '/integrations/zoho_crm?section=map' };

/** Pure: the waiting names as bell rows. */
export function crmStageRows(waiting) {
  return (Array.isArray(waiting) ? waiting : []).filter((w) => w && w.value).map((w) => ({
    id: `crm-stage-${w.connection}-${String(w.value).toLowerCase()}`,
    tone: 'warn',
    text: `${CRM_NAME[w.connection] || 'Your CRM'} sent the stage "${w.value}": ${w.n} update${w.n === 1 ? '' : 's'} waiting for you to confirm it`,
    to: CARD_PATH[w.connection] || '/integrations',
    linkLabel: 'Confirm the stage',
  }));
}

export function useCrmStageAlerts() {
  const { data } = useQuery({
    queryKey: ['crm-inbound', 'waiting'],
    queryFn: async () => (await api.get('/api/crm/waiting')).data,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });
  return crmStageRows(data?.waiting);
}
